import React from 'react';
import './_switchbutton.scss';

import Arrow from '../../../resources/icons/arrow.svg';
import ArrowDown from '../../../resources/icons/arrow-down';

const Switchbutton = ({children}) => (
    <div className="nav-switcher">
        <a className="nav-switcher--button">
            <span className="featured">Ihre&nbsp;Bilder</span>
           <ArrowDown/>
        </a>
        <div className="nav-switcher--links">
            <a href="https://xrweb.mr-vorarlberg.at/Login/IndexTan" className="nav-switcher--link no-border no-hover">Für Patienten</a>
            <a href="https://xrweb.mr-vorarlberg.at" className="nav-switcher--link no-border no-hover">Für Zuweiser</a>
        </div>
    </div>
)

export default Switchbutton


// WEBPACK FOOTER //
// ./src/components/navigation/switchbutton/index.jsx